export class UserDetailsModel{
    empyeeId:number;
    orgsmId:number;
    languCode:number;
    partnerId:number;
    partnerType:number;
    patypCode:number;
    secProId:number;
    secSubProId:number;
    staRecCode:string;
    secUsrLogin:string;
    secUsrPwd:string;
    secUsrCnfrmPwd:string;
    cotryIdDefault:number;
    applicationId:number;
}